module.exports = __webpack_public_path__ + "img/minilogo.c82b731e.svg";